function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelect } from 'downshift';
import noop from 'lodash/noop';
import { ChevronDownIconSmall, MoreCircleIcon } from '@domain-group/fe-co-icon';
import Loader from '@domain-group/fe-co-loader';
import SelectRoot from './select-root';
import * as styles from './select.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Size = Object.freeze({
  Small: 'small',
  Regular: 'regular'
});
export var itemToString = item => typeof (item === null || item === void 0 ? void 0 : item.label) === 'undefined' || !item ? '' : String(item.label);
function Select(props) {
  var _selectedItem$value;
  var instanceId = props.instanceId,
    size = props.size,
    disabled = props.disabled,
    loading = props.loading,
    label = props.label,
    autoFocus = props.autoFocus,
    isInvalid = props.isInvalid,
    optionComponent = props.optionComponent,
    onOpen = props.onOpen,
    onClose = props.onClose,
    onFocus = props.onFocus,
    onChange = props.onChange,
    className = props.className,
    labelHidden = props.labelHidden,
    floatingLabel = props.floatingLabel,
    appearance = props.appearance,
    nowrap = props.nowrap,
    alignBody = props.alignBody,
    dropdownMaxHeight = props.dropdownMaxHeight,
    stretched = props.stretched,
    required = props.required,
    hideSelectedOption = props.hideSelectedOption,
    environment = props.environment,
    value = props.value;
  var placeholder = loading ? 'Loading...' : props.placeholder;
  var options = loading ? [] : props.options;
  var isSmall = size === Size.Small;
  var getSelectedItem = useCallback(() => {
    var _props$options;
    if (props.value === null) {
      return null;
    }
    return ((_props$options = props.options) !== null && _props$options !== void 0 ? _props$options : []).find(item => {
      var _props$value;
      return item.value === ((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : props.defaultValue);
    });
  }, [props.value, props.defaultValue, props.options]);
  var _useState = useState(getSelectedItem()),
    _useState2 = _slicedToArray(_useState, 2),
    selectedItemState = _useState2[0],
    setSelectedItemState = _useState2[1];
  useEffect(() => {
    setSelectedItemState(getSelectedItem());
  }, [props.value, props.defaultValue, getSelectedItem]);
  var handleChange = useCallback(nextSelectedItem => {
    onChange === null || onChange === void 0 ? void 0 : onChange(nextSelectedItem.selectedItem);
  }, [onChange]);
  var stateChangeHandler = useCallback(_ref => {
    var isOpen = _ref.isOpen,
      nextSelectedItem = _ref.selectedItem;
    if (isOpen === false && onClose) {
      onClose();
    }
    if (isOpen === true && onOpen) {
      onOpen();
    }
    var componentIsNotControllerByProps = !value && selectedItemState;
    if (componentIsNotControllerByProps) {
      setSelectedItemState(nextSelectedItem);
    }
  }, [onClose, onOpen, value, selectedItemState]);
  var _useSelect = useSelect(_objectSpread({
      id: instanceId,
      items: options,
      itemToString,
      onSelectedItemChange: handleChange,
      selectedItem: selectedItemState,
      onStateChange: stateChangeHandler
    }, !!environment && {
      environment
    })),
    id = _useSelect.id,
    highlightedIndex = _useSelect.highlightedIndex,
    isOpen = _useSelect.isOpen,
    getItemProps = _useSelect.getItemProps,
    getLabelProps = _useSelect.getLabelProps,
    getToggleButtonProps = _useSelect.getToggleButtonProps,
    getMenuProps = _useSelect.getMenuProps,
    selectedItem = _useSelect.selectedItem;
  var hasLabel = selectedItem && selectedItem.label;
  var visibleLabel = selectedItem && selectedItem.label || placeholder;
  if (floatingLabel) {
    visibleLabel = hasLabel ? selectedItem.label : '';
  }
  var visualState = {
    isOpen,
    isSmall,
    hasLabel,
    isInvalid,
    disabled,
    loading,
    labelHidden,
    floatingLabel,
    hasSelectedItem: !!selectedItem,
    appearance,
    nowrap,
    alignBody,
    dropdownMaxHeight,
    hideSelectedOption
  };
  var buttonProps = getToggleButtonProps({
    autoFocus,
    css: styles.selectedItem(visualState),
    disabled: disabled || loading,
    onFocus
  });
  var labelElement = ___EmotionJSX("label", _extends({
    // eslint-disable-line jsx-a11y/label-has-for
    css: styles.label(visualState),
    htmlFor: "".concat(id, "-input")
  }, getLabelProps()), label, required && ___EmotionJSX("span", {
    className: "input-wrapper__required",
    css: styles.required,
    role: "presentation",
    "aria-hidden": true
  }, "*"));
  return ___EmotionJSX(SelectRoot, {
    css: styles.domainSelect(_objectSpread(_objectSpread({}, visualState), {}, {
      stretched
    })),
    className: className
  }, !floatingLabel && labelElement, ___EmotionJSX("div", {
    css: styles.selectedItemWrapper(visualState)
  }, ___EmotionJSX("button", _extends({}, buttonProps, {
    css: styles.selectedItem(visualState),
    autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
    ,
    onFocus: onFocus,
    disabled: disabled || loading,
    type: "button"
  }), !hideSelectedOption && visibleLabel, appearance === 'borderless' && hideSelectedOption && ___EmotionJSX(MoreCircleIcon, {
    css: styles.moreIcon,
    size: "custom"
  })), floatingLabel && labelElement, loading && ___EmotionJSX(Loader, {
    css: styles.loader,
    size: "mini",
    transparent: true
  }), ___EmotionJSX("input", {
    css: styles.inputField,
    value: (_selectedItem$value = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) !== null && _selectedItem$value !== void 0 ? _selectedItem$value : ''
  }), appearance === 'borderless' && !hideSelectedOption && ___EmotionJSX(ChevronDownIconSmall, {
    css: styles.chevron(visualState)
  })), ___EmotionJSX("div", {
    css: styles.menuOuter(visualState),
    "data-testid": "domain-select-menu-container"
  }, ___EmotionJSX("ul", _extends({
    "data-testid": "domain-select-menu",
    css: styles.menu({
      dropdownMaxHeight
    })
  }, getMenuProps()), isOpen && options.map((item, index) => {
    if (optionComponent) {
      return optionComponent(item, index, highlightedIndex, selectedItem, getItemProps);
    }
    return ___EmotionJSX("li", getItemProps({
      item,
      index,
      key: item.value,
      css: styles.item(_objectSpread(_objectSpread({}, visualState), {}, {
        isHighlighted: highlightedIndex === index,
        isSelected: highlightedIndex === null && selectedItem === item
      }))
    }), item.label);
  }))));
}
Select.propTypes = {
  instanceId: PropTypes.string,
  options: PropTypes.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.node,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  isInvalid: PropTypes.bool,
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
  size: PropTypes.string,
  optionComponent: PropTypes.func,
  label: PropTypes.node.isRequired,
  labelHidden: PropTypes.bool,
  onFocus: PropTypes.func,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  className: PropTypes.string,
  floatingLabel: PropTypes.bool,
  appearance: PropTypes.oneOf(['regular', 'borderless', 'rounded']),
  alignBody: PropTypes.oneOf(['left', 'right']),
  nowrap: PropTypes.bool,
  dropdownMaxHeight: PropTypes.number,
  stretched: PropTypes.bool,
  required: PropTypes.bool,
  hideSelectedOption: PropTypes.bool,
  environment: PropTypes.shape({
    addEventListener: PropTypes.func.isRequired,
    removeEventListener: PropTypes.func.isRequired,
    document: PropTypes.shape({
      createElement: PropTypes.func.isRequired,
      getElementById: PropTypes.func.isRequired,
      // eslint-disable-next-line react/forbid-prop-types
      activeElement: PropTypes.any.isRequired,
      // eslint-disable-next-line react/forbid-prop-types
      body: PropTypes.any.isRequired
    }).isRequired,
    Node: PropTypes.func.isRequired
  })
};
Select.defaultProps = {
  instanceId: undefined,
  defaultValue: undefined,
  value: undefined,
  placeholder: '',
  disabled: false,
  loading: false,
  isInvalid: false,
  onChange: noop,
  autoFocus: false,
  size: Size.Regular,
  optionComponent: undefined,
  labelHidden: false,
  onFocus: noop,
  onClose: noop,
  onOpen: noop,
  className: '',
  floatingLabel: false,
  appearance: 'regular',
  alignBody: 'left',
  nowrap: false,
  dropdownMaxHeight: styles.defaultDropdownMaxHeight,
  stretched: false,
  required: false,
  hideSelectedOption: false,
  environment: undefined
};
export default Select;